"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;
var _react = _interopRequireDefault(require("react"));
require("../cdn.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Grid = exports.Grid = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    mt = 7,
    children,
    className = ""
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: ["grid", "mt-".concat(mt), ...className.split(" ")].filter(v => !!v).join(" "),
    ref: ref
  }, children);
});